import ContentLoader from 'react-content-loader'
import homeimg2 from "../../assest/images/expimg1.png";
const SKProductList = ({ records }) => {
    const skeletonRows = Array.from({ length: records });
    return (
        skeletonRows.map((_, rowIndex) => (
            // <div className="listBoxproduct" style={{ border: "unset", marginBottom: "unset" }} key={rowIndex}>
            //     <ContentLoader
            //         backgroundColor="#e0e0d9"
            //         foregroundColor="#d6d6d0"
            //         speed={1}
            //         // viewBox="0 0 760 150"
            //         viewBox={`0 0 ${window.innerWidth-200} 200`}
            //         height={200} 
            //         width={window.innerWidth-300}>
            //         <rect x="0" y="0" rx="10" ry="10" width={window.innerWidth-300} height="200" />
            //     </ContentLoader>
            // </div>
            <div className="ourTourBox skeleton"  key={rowIndex}>
                <div className="leftImg">
                    <img src={homeimg2} alt="expimg1" />
                </div>
                <div className="rightText">
                    <p><i className="fa-solid fa-location-dot"></i>Portugal, Azores Archipelago, Angra do
                        Heroísmo</p>
                    <h5>Paris: Graves of the Famous Private Guided Walking Tour</h5>
                    <ul>
                        <li>
                            <p><i className="fa-solid fa-user-group"></i> Groups</p>
                        </li>
                        <li>
                            <p><i className="fa-solid fa-clock"></i> Duration 3 hours 15 minutes</p>
                        </li>
                    </ul>
                    <div className="priceBox">
                        <h6>From € 340</h6>
                        <p><i className="fa-solid fa-star"></i> 4.8 <span>(12 reviews)</span></p>
                    </div>
                </div>
            </div>

        ))
    )
}
export default SKProductList